import React, { Component } from "react";
import PropTypes from 'prop-types';
// import Graphics from "./components/graphics/Graphics";
import { Graphics } from './components/Graphics';

// import Controls from "components/pipette/Controls";
import {MoveMenu} from "./components/MoveMenu"


import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { css } from "glamor";
import Toast from "../toast/Toast";
import Move from "./img/move.svg";

import "./AgaroseGel.scss";
import colors from '@learningblocks/protocol-constants/lib/Styles/_colors.scss';


export class AgaroseGel extends Component {
constructor(props) {
  super(props);

  this.state = {}

  const interactions = (heldObj, target) => {
    //Don't run if this gel not the held object
    if(heldObj.type !== "AgaroseGel" || heldObj.id !== this.props.id){
      return null;
    }
    if (target === undefined || target === null) {
      this.props.setGelOnShelf({
        id: this.props.id,
        onShelf: false
      });
      return null;
    }

    console.log(target);


    //All Transilluminator interactions
    if (target.type === "Transilluminator") {
      //Get the targeted TipBox
      // const gelsID = target.id
      const gelsID = 1
      // const targetTransilluminator = this.props.interactionProps.transilluminator[gelsID - 1]
      const targetTransilluminator = this.props.interactionProps.transilluminator[0]

      if(targetTransilluminator.open) {

        //Tip Box open - attach tip
        if (!targetTransilluminator.containsGel) {
          //No tip attached - can attach new tip

          this.props.setGelInScene({
            id: this.props.id,
            inScene: false,
          });
          this.props.setGelInTransilluminator({
            id: gelsID,
            containsGel: true,
          });
          this.props.setGelOnShelf({
            id: this.props.id,
            onShelf: false
          });

          heldObj.htmlObj.style.transform = "translate3d(0px,0px,0px) rotateZ(0deg)"

        } else {
          //Alert - pipette already has a tip attached
          this.makeToast("WARNING", "The transilluminator already has a gel inside.", "transilluminator full!")
        }
      } else if(!targetTransilluminator.open){

        this.makeToast("WARNING", "You need to open the lid of the transilluminator fist.", "transilluminator closed!")
      } else {
        return null;
      }
    } else if(target.type === "Shelf") {

      this.props.setGelOnShelf({
        id: this.props.id,
        onShelf: true
      });

      this.props.setGelHeld({
        id: this.props.id,
        held: false
      });

    } else {

      this.props.setGelOnShelf({
        id: this.props.id,
        onShelf: false
      });

      this.props.setGelHeld({
        id: this.props.id,
        held: false
      });
    }
    //All GelBox interactions
    if (target.type === "GelBox") {
      //Get the targeted TipBox
      const gelsID = target.id
      const targetGelBox = this.props.interactionProps.gelBoxes[gelsID - 1]

      if(targetGelBox.open) {

        //Tip Box open - attach tip
        if (!targetGelBox.containsGel) {
          //No tip attached - can attach new tip

          this.props.setGelInScene({
            id: this.props.id,
            inScene: false,
          });
          this.props.setGelInBox({
            id: gelsID,
            gelId: this.props.id,
            containsGel: true,
          });
          this.props.setGelOnShelf({
            id: this.props.id,
            onShelf: false
          });
          heldObj.htmlObj.style.transform = "translate3d(0px,0px,0px) rotateZ(0deg)"


        } else {
          //Alert - pipette already has a tip attached
          this.makeToast("WARNING", "The gel box already has a gel inside.", "Gel box full!")
        }
      } else if(!targetGelBox.open){

        this.makeToast("WARNING", "You need to open the lid of the gel box fist.", "Gel box closed!")
      } else {
        return null;
      }
    } else if(target.type === "Shelf") {

      this.props.setGelOnShelf({
        id: this.props.id,
        onShelf: true
      });

      this.props.setGelHeld({
        id: this.props.id,
        held: false
      });

    } else {

      this.props.setGelOnShelf({
        id: this.props.id,
        onShelf: false
      });

      this.props.setGelHeld({
        id: this.props.id,
        held: false
      });
    }
  }

  Object.defineProperty(interactions, 'name', {value: ('gel_interactions_'+this.props.id), configurable: true});
  console.log('interactions: ', interactions);
  this.props.pushInteractions([interactions]);
}

componentWillMount() {
  this.props.createAgaroseGel({
    props: this.props.defaultProps,
  });
}

makeToast = (type, msg, title) => {
  let color = "";
  if (type === "HINT") {
    color = colors.yellow1;
  } else {
    color = colors.red1;
  }

  toast(<Toast type={type} msg={msg} title={title} />,{
    className: css({
      border: "2px solid "+color,
      borderRadius: "6px",
      marginLeft: "-200px",
      minWidth: "400px",
      paddingLeft: 0
    }),
    progressClassName: css({
      background: color
    }),
    position: "top-center",
    autoClose: 5000,
  });
}

showControls = ()=> {
  this.props.hideAllControls();
  this.props.setGelControlVisibility({id: this.props.id, controlsVisible: true});
}

gelSelected = (e) => {

  if(!this.props.controlsVisible){
      this.showControls()
  }

  this.props.setGelHeld({
    id: this.props.id,
    held: true,
  })

  // this.props.setSolutionHeld({
  //   id: this.props.id,
  //   held: true,
  // });
  this.props.setHeldObject({
    id: this.props.id,
    type: "AgaroseGel",
    htmlObj: e.target,
  });

}

gelUnselected = (e) => {
  this.props.setGelHeld({
    id: this.props.id,
    held: false,
  })
}

showMoveMenu = e => {
  this.props.setMoveMenu({
    type: this.props.type,
    connect: this.props.id
  });
  this.props.showMoveMenu({ display: !this.props.moveMenuDisplay });
};

render(){
  return (
      <ul style={{ display:(!this.props.inScene)?'none':null, zIndex: (this.props.controlsVisible)?99:null }}>
         <li
            onKeyDown={ (e)=>{if(e.keyCode === 13 || e.keyCode === 32) this.gelSelected() } }
            onMouseDown={this.gelSelected}
            onDragStart={(e) => this.gelSelected(e)}
            onDragEnd={(e) => this.gelUnselected(e)}
            // onDragEnd={(e) => {
            //   this.props.setSolutionHeld({
            //     id: this.props.id,
            //     held: false,
            //   });
            // }}
            draggable
            tabIndex={0}
            id={"AgaroseGel_"+this.props.id}
            className = {"Gel draggable droptarget"+ this.props.id}
             style={{ transform: "translate3d(0px, 0px, 0px) rotateZ(0deg)" }}>
            <p className="label" aria-hidden="true">{this.props.type}</p>
            <Graphics id={this.props.id}/>
            <div className="move-menu" style={{ display: this.props.controlsVisible ? null : "none" }}>
                <button
                  tabIndex={0}
                  className="move-button"
                  onClick={this.showMoveMenu}
                  aria-label="Move menu. Select to view the available positions."
                >
                  <img src={Move} alt="Move menu icon." />
                </button>
                <MoveMenu type={this.props.type} connect={this.props.id} />
              </div>
          </li>
      </ul>
    );
  }
}


AgaroseGel.propTypes = {
  createAgaroseGel: PropTypes.func,
  // setGelHeld: PropTypes.func,
  // pushInteractions: PropTypes.func,
}

AgaroseGel.defaultProps = {

}
